module.exports = __webpack_public_path__ + "img/service3.902eddbc.png";